import {ISVG} from "../../common/Logo/Logo";

export interface ICircle2Props extends Pick<ISVG, "fill"> {}

export const Circle3 = ({ fill }: ICircle2Props) => {
    const _fill = fill ?? "#46B3A5";

    return (
        <svg
            width="154"
            height="153"
            viewBox="0 0 154 153"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M73.7352 0.123956C95.5541 -0.723521 118.584 2.52288 134.23 17.7169C150.032 33.0624 154.194 56.0656 153.993 78.0638C153.794 99.8252 149.137 122.527 133.136 137.319C117.566 151.712 94.9189 153.608 73.7352 152.253C54.1153 150.998 35.3283 144.112 21.4929 130.178C7.72363 116.311 0.7417 97.5706 0.0697575 78.0638C-0.628725 57.7866 3.82207 37.0025 17.7747 22.2402C32.0835 7.10122 52.8931 0.933493 73.7352 0.123956Z"
                fill={_fill}
            />
        </svg>
    );
};
